module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jPyjT"))).then(() => parcelRequire('hEqeo'));